import { defineFcm } from '../shared/factory';

export const FCM_HIGH_AMOUNT_CONFIRMATION_MODAL = defineFcm('high_amount_confirmation_modal')
	.asBoolean()
	.withDefault(false)
	.toConfig();
